import { defineAsyncComponent } from 'vue';

const ConnectQLTSDetail = defineAsyncComponent(() => import('@/views/connect/connectDetail/ConnectQLTSDetail.vue'));

const MappingSourceQLTSDetail = defineAsyncComponent(() =>
  import('@/views/connect/connectDetail/MappingSourceQLTSDetail.vue')
);

export function registerConnect(app) {
  app.component('ConnectQLTSDetail', ConnectQLTSDetail);
  app.component('MappingSourceQLTSDetail', MappingSourceQLTSDetail);
}
